module.exports = __webpack_public_path__ + "img/3267a0ca0aceee10ea741588fd3c8eb0.png";